import { api } from './graphql';

api.enhanceEndpoints({
  endpoints: {
    AdminUsers: { providesTags: ['User'] },
    CreateUser: { invalidatesTags: ['User'] },
    LinkFusionAuthUser: { invalidatesTags: ['User'] },
    DeleteUser: { invalidatesTags: ['User'] },
  },
});
